import { RefreshCircleSolid } from 'iconoir-react';
import { PhotoButtonProps } from '../../types/Generics/PhotoButtonProps';

export const RetakePhoto = (props: PhotoButtonProps) => {
  return (
    <button onClick={props.setter}>
      <RefreshCircleSolid />
    </button>
  );
};
